import { render, staticRenderFns } from "./ServerErrorModal.vue?vue&type=template&id=12983a1a&"
import script from "./ServerErrorModal.vue?vue&type=script&lang=js&"
export * from "./ServerErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports